import { gql } from "@apollo/client";
import RelatedExperiences from "components/ExperiencePresentation/RelatedExperiences/RelatedExperiences";
import Layout from "components/Layout";
import PageIntro from "components/content/PageIntro/PageIntro";
import { site } from "config";
import {
  fetchExperiencesByCategory,
  processExperienceData,
} from "lib/api/strapi-experiences";
import { fetchLayoutData, fetchLayoutDataServer } from "lib/api/strapi-layout";
import { graphQlClient } from "lib/graphql-client.js";
import styles from "./ExperienceCategory.module.scss";

export default function ExperienceCategory({ pageData, layoutData }) {
  const { slug, SEO, page_intro, experiences } = pageData;

  const processedSEO = {
    ...SEO,
    canonicalURL: `${site}/experiences/${slug}`,
  };

  return (
    <Layout seo={processedSEO} layoutData={layoutData}>
      <div className={`variable-container`}>
        <PageIntro
          title={page_intro.page_title}
          description={page_intro.page_introduction}
          layout="imageRight"
          image={page_intro?.intro_photo?.url}
        />
        <section className={`${styles.experiences}`}>
          <RelatedExperiences
            experiences={experiences}
            sideScroll="none"
            titleType="p"
            sideScrollButtons={false}
            scrollIndicator={false}
          />
        </section>
      </div>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const { categorySlug } = context.params;

  const experienceCategoryData = await fetchExperiencesByCategory(categorySlug);

  const experienceCategory = experienceCategoryData[0]?.data?.attributes;

  const pageData = {
    ...experienceCategory,
    experiences: experienceCategory?.experiences?.map((experience) => {
      return processExperienceData(experience, { type: "basic" });
    }),
    page_intro: {
      ...experienceCategory?.page_intro,
      intro_photo: {
        url: experienceCategory?.page_intro?.intro_photo?.data?.attributes?.url,
      },
    },
    seo: {
      ...experienceCategory?.SEO,
      metaMedia: {
        ...experienceCategory?.SEO?.metaMedia?.data?.attributes,
      },
    },
  };

  // const layoutData = await fetchLayoutData();
  const layoutData = await fetchLayoutDataServer();

  return {
    props: {
      pageData,
      layoutData,
    },
  };
}

export async function getStaticPaths() {
  const strapiApolloClient = graphQlClient();

  let experienceCategoriesResponse = await strapiApolloClient.query({
    query: gql`
      query ExperienceCategoriesQuery {
        experienceCategories {
          data {
            attributes {
              slug
            }
          }
        }
      }
    `,
  });

  const paths = experienceCategoriesResponse.data.experienceCategories.map(
    (category) => {
      return { params: { categorySlug: category.data.attributes.slug } };
    }
  );

  return {
    paths: paths,
    fallback: false,
  };
}
